import InvoiceItem from "./invoice-item";

class DataLayer {
  constructor() {
    this.state = {
      /**
       * The invoice items. This can be either an animal or an item, defined by a user.
       * @type {InvoiceItem[]}
       */
      invoiceItems: [],
      /**
       * Items that can be added to the invoice, defined by user.
       */
      items: [],
      /**
       * Animals that can be added to the invoice. These are a result of:
       * - regular hunting (book record animals)
       * - collective hunting (old group hunting)
       * - group hunting
       *
       * They can be uniquely identified by `id` and `type` fields (union identifier).
       */
      animals: [],
      collectionCentres: [],
      entities: [],
      currentEntityId: null
    }
  }

  initialize() {
    this.state.items = JSON.parse(window._itemsData ?? '[]');
    this.state.collectionCentres = JSON.parse(window._collectionCentres ?? '[]');
    this.state.entities = JSON.parse(window._entitiesData ?? '[]');
    this.state.animals = JSON.parse(window._data ?? '[]');
  }

  addItem(item) {
    this.state.items = [...this.state.items, item];
  }

  updateItem(item, query) {
    const index = this.state.items.findIndex(query);
    if (index === -1) {
      return;
    }
    this.state.items[index] = {...this.state.items[index], ...item};
  }

  updateAnimal(animal, query) {
    const index = this.state.animals.findIndex(query);
    if (index === -1) {
      return;
    }
    this.state.animals[index] = {...this.state.animals[index], ...animal};
  }

  addInvoiceItem(itemOrAnimal) {
    this.state.invoiceItems = [...this.state.invoiceItems, new InvoiceItem(itemOrAnimal)];
  }

  removeInvoiceItem(id, type, uuid = null) {
    if(uuid) {
      this.state.invoiceItems = this.state.invoiceItems.filter(i => i.uuid !== uuid);
      return
    }

    this.state.invoiceItems = this.state.invoiceItems.filter(i => !(parseInt(i.id) === parseInt(id) && i.type === type));
  }

  resetInvoiceItemsNo() {
    this.state.invoiceItems
      .filter(i => !i.isAfterCorrection)
      .sort((a, b) => b-a).forEach((item, index) => item.no = index + 1);
  }

  setCurrentEntityId(id) {
    this.state.currentEntityId = id;
  }

  getInvoiceItem(uniqueId) {
    return this.state.invoiceItems.find(i => i.uniqueId === uniqueId) ?? null;
  }

  get currentEntity() {
    return this.state.entities.find(e => e.id === this.state.currentEntityId) ?? null;
  }

  /**
   * Get the animals that can be added to the invoice.
   */
  get availableAnimals() {
    return this.state.animals.filter(a => !this.state.invoiceItems.some(i => i.id === a.id && i.type === a.type));
  }
}

// Export a singleton instance, if desired.
const dataLayer = new DataLayer();
export default dataLayer;